import { client } from '../utils/fetch';
import { StoreListResponse } from '../types/Store';

const API_ENDPOINT = 'stores';

const headers = {
  'Content-Type': 'application/json;charset=UTF-8',
};

export const getStores = async (active: number = 1, condition?: string): Promise<StoreListResponse> => {
  try {
    const response = await client.get<StoreListResponse>(`${API_ENDPOINT}`, headers);
    return response;
  } catch (error) {
    console.error("Error fetching stores:", error);
    throw error;
  }
};

export const addStore = async (storeData: { number: string, name: string, address: string }): Promise<any> => {
  try {
    const response = await client.post<any>(`${API_ENDPOINT}/add`, storeData, headers);
    return response;
  } catch (error) {
    console.error("Error adding store:", error);
    throw error;
  }
}; 
